import '../../resources/css/visual/ProjectForm.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import { maxLength32, maxLength256, verifyForm, validateNull } from '../common/access-form-validation';
import { popupModalConfirm, openModalAlert, openPickModal, closeModal, openModalTip } from '../../actions/index';
import { commonRenderInput, commonRenderSelect } from '../common/access-form';
import Loading from '../common/Loading';
import { checkTableAuth } from '../common/access-auth';
import { doSaveFloorPlanData, doSelectFloorPlanProject } from '../../actions/visual';
import { doActivePage } from '../../actions/menu';

class ProjectForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: []
        }
    }

    formSubmit = (values) => {
        const { doSaveFloorPlanData, authToken, formValues, popupModalConfirm, openModalAlert, accountRole, roleTableAuth } = this.props;
        if (checkTableAuth('settings', accountRole, roleTableAuth, 2)) {

            popupModalConfirm('Confirm', 'icon-alert', 'Confirm to change?', 300, () => doSaveFloorPlanData(formValues, authToken), null, false);

        } else {
            openModalAlert("Sorry, you don't have permission to change config.");
        }
    }

    handleSelectEnvironment = () => (e) => {
        const { change } = this.props;
        let select = e.target;
        change('environment', select.value);

    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

   

    render() {
        const { handleSubmit, floorPlanData, verifyFormPass, formValues, modalMessage, doActivePage, doSelectFloorPlanProject, closeModal } = this.props;
        if (modalMessage !== 'view' && formValues) {
            return (
                <div className="project-settings-form form-custom global-ap-setting-edit">

                    <form onSubmit={handleSubmit(this.formSubmit)}>
                        <div>
                            <Row style={{ height: '20px' }}>
                                <Col className='form-area-title'>
                                    <span>Name</span>
                                </Col>
                            </Row>
                            <Row style={{ height: '40px' }}>
                                <Col className='form-area-label custom-field'>
                                    <Field
                                        id="add-new-project-name"
                                        name={'name'}
                                        type="text"
                                        component={commonRenderInput}
                                        placeholder='Please input the project name'
                                        validate={[maxLength32, validateNull]}
                                    />
                                </Col>
                            </Row>

                            <Row style={{ height: '20px' }}>
                                <Col className='form-area-title'>
                                    <span>Building Type</span>
                                </Col>
                            </Row>

                            <Row style={{ height: '40px' }}>
                                <Col className='form-area-label'>
                                    <Field id="add-new-project-building-type" name={'environment'}
                                        options={['office', 'store', 'factory', 'home', 'free-space path loss']}
                                        callback={this.handleSelectEnvironment()}
                                        component={commonRenderSelect}

                                    />
                                </Col>
                            </Row>

                            <Row style={{ height: '20px' }}>
                                <Col className='form-area-title'>
                                    <span>Description</span>
                                </Col>
                            </Row>

                            <Row style={{ height: '40px' }}>
                                <Col className='form-area-label custom-field'>
                                    <Field
                                        id="add-new-project-description"
                                        name={'description'}
                                        type="text"
                                        component={commonRenderInput}
                                        placeholder='Please input the project description'
                                        validate={maxLength32}
                                    />
                                </Col>
                            </Row>

                            <Row style={{ height: '20px' }}>
                                <Col className='form-area-title'>
                                    <span>Address</span>
                                </Col>
                            </Row>

                            <Row style={{ height: '40px' }}>
                                <Col className='form-area-label custom-field'>
                                    <Field
                                        id="add-new-project-address"
                                        name={'address'}
                                        type="text"
                                        component={commonRenderInput}
                                        placeholder='Please input the project address'
                                        validate={maxLength256}
                                    />
                                </Col>
                            </Row>

                        </div>
                        <Button id="add-new-project-save" type="submit" bsPrefix='btn btn-save' disabled={!verifyFormPass}>Save</Button>
                    </form>

                </div>
            );
        } else if (floorPlanData && formValues && modalMessage === 'view') {
            return (
                <div className='project-settings-form-view form-custom'>
                    <Row>
                        <Col className="area-form-label">Name</Col>
                        <Col className="area-form-field">{formValues["name"]}</Col>
                    </Row>
                    <div className="content-line"></div>
                    <Row>
                        <Col className="area-form-label">Building Type</Col>
                        <Col className="area-form-field">{formValues["environment"]}</Col>
                    </Row>
                    <div className="content-line"></div>
                    <Row>
                        <Col className="area-form-label">Description</Col>
                        <Col className="area-form-field">{formValues["description"]}</Col>
                    </Row>
                    <div className="content-line"></div>
                    <Row style={{ marginBottom: '20px', wordBreak: 'break-all' }}>
                        <Col xs={4} className="area-form-label">Address</Col>
                        <Col xs={8} className="area-form-field">{formValues["address"]}</Col>
                    </Row>

                    <Button id="project-info-opent-project" variant="primary" size="lg" bsPrefix='btn btn-custom' onClick={()=> {doActivePage("rf_map/floorplan"); doSelectFloorPlanProject(formValues["seq"], formValues["environment"], formValues["address"]); closeModal(null);}}>Open Project</Button>

                </div>
            );
        } else {
            return (<Loading loading={true}></Loading>);
        }
    }
}

const getverifyField = () => {
    let verifyFields = null
    verifyFields = ['name'];

    return verifyFields;
}

const mapStateToProps = (state, ownProps) => {
    let floorPlan = state.visualReducers.floorPlan;
    const modalMessage = state.commonReducers.modalMessage;
    const verifyFormPass = verifyForm(state.form['ProjectForm'], getverifyField(modalMessage));


    let result = {
        selectSite: state.siteReducers.selectSite,
        authToken: state.loginReducers.authToken,
        roleTableAuth: state.loginReducers.roleTableAuth,
        accountRole: state.loginReducers.accountRole,
        floorPlanData: floorPlan,
        status: state.settingsReducers.status,
        formValues: getFormValues('ProjectForm')(state),
        verifyFormPass: verifyFormPass,
        modalMessage: modalMessage,
    }
    if (floorPlan) {
        let initialValues = {};
        initialValues['seq'] = floorPlan.seq ?? 0;
        initialValues['site'] = floorPlan.site ?? state.siteReducers.selectSite;
        initialValues['name'] = floorPlan.name;
        initialValues['environment'] = floorPlan.environment;
        initialValues['description'] = floorPlan.description;
        initialValues['address'] = floorPlan.address;

        result['initialValues'] = initialValues;
    } else {
        let initialValues = {};
        initialValues['site'] = state.siteReducers.selectSite;
        initialValues['name'] = "";
        initialValues['environment'] = "office";
        initialValues['description'] = "";
        initialValues['address'] = "";
        result['initialValues'] = initialValues;
    }

    return result;

}

ProjectForm = reduxForm({
    form: 'ProjectForm',  // a unique identifier for this form
    enableReinitialize: true
})(ProjectForm)


export default connect(
    mapStateToProps,
    { doSaveFloorPlanData, popupModalConfirm, openModalAlert, openPickModal, closeModal, openModalTip, doActivePage, doSelectFloorPlanProject }
)(ProjectForm);